import BusinessStatistics from '@/models/loyaltyPanel/BusinessStatistics';
const getDefaultState = () => ({
  businessStatistics: [],
  activeUsers: null,
  last2MonthsActiveUsers: null,
  companyRegions: [],
  businessStatisticsTotals: {},
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setBusinessStatistics(state, payload) {
      state.businessStatistics = payload;
    },
    setActiveUsers(state, payload) {
      state.activeUsers = payload;
    },
    setLast2MonthsActiveUsers(state, payload) {
      state.last2MonthsActiveUsers = payload;
    },
    setCompanyRegions(state, payload) {
      state.companyRegions = payload;
    },
    setBusinessStatisticsTotals(state, payload) {
      state.businessStatisticsTotals = payload;
    },
  },

  actions: {
    async getBusinessStatisticsTotals({ commit }, body) {
      try {
        commit('setLoading', true, { root: true });
        let filter = '';
        Object.keys(body.filters).map((key) => {
          if (body.filters[key]) {
            filter += '&' + key + '=' + body.filters[key];
          }
        });
        const { data } = await BusinessStatistics.getTotals(body.query, filter);
        const businessStatisticsTotal = data.data.data[0];
        businessStatisticsTotal.store_name = 'Company total';
        commit('setBusinessStatisticsTotals', businessStatisticsTotal);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async getBusinessStatistics({ commit, state, dispatch }, body) {
      try {
        commit('setLoading', true, { root: true });
        let filter = '';
        Object.keys(body.filters).map((key) => {
          if (body.filters[key]) {
            filter += '&' + key + '=' + body.filters[key];
          }
        });
        const totalsBody = {
          query: '?page=1',
          filters: {
            is_company: true,
            type: body.filters.type,
            start_date: body.filters.start_date,
            end_date: body.filters.end_date,
            region: body.filters.region,
            order: body.filters.order,
            q: body.filters.q,
          },
        };
        await dispatch('getBusinessStatisticsTotals', totalsBody);

        const { data } = await BusinessStatistics.get(body.query, filter);
        const businessStatistics = data.data.data;
        businessStatistics.push(state.businessStatisticsTotals);
        const pagination = data.data.pagination;
        commit('setBusinessStatistics', businessStatistics);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });

        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async getActiveUsers({ commit }) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await BusinessStatistics.getActiveUsers();

        const activeUsers = data.data[0].active_users;

        commit('setActiveUsers', activeUsers);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async getCompanyRegions({ commit }) {
      try {
        const { data } = await BusinessStatistics.getCompanyRegions();

        const regions = data.data;

        commit('setCompanyRegions', regions);
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async getLast2MonthsActiveUsers({ commit }) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await BusinessStatistics.getLast2MonthsActiveUsers();

        const last2MonthsActiveUsers = data.data[0].active_users;

        commit('setLast2MonthsActiveUsers', last2MonthsActiveUsers);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },
  },
};
